import TruthTable from "./TruthTable";
function MultiTruthTable(props) {
  if (props.TaskItemData.type !== 'MultiTruthTable') return <></>
  console.log(props);
  const table = props.TaskItemData['taskDataList'].map((Taskit,ind)=>{
    return <TruthTable key={Taskit['taskId']+ind} TaskItemData={Taskit}  setTaskData={props.setTaskData}></TruthTable>
  })
  return table
}
export default MultiTruthTable